import { useSelector } from 'react-redux';
import { selectCatalogBySegment } from 'selectors/productsCartSelectors';

/**
 * useProductsCatalog hook.
 * Provides products catalog data from Redux state.
 *
 * @param {string} segment - Segment of the journey: 'outgoing', 'incoming', or 'both' to get products from both segments
 * @returns {Array} Catalog products list
 */
export const useProductsCatalog = (segment = 'outgoing') => {
  const catalogOutgoing = useSelector(selectCatalogBySegment('outgoing'));
  const catalogIncoming = useSelector(selectCatalogBySegment('incoming'));

  if (segment === 'both') {
    // Combine both catalogs using Map, avoiding duplicates by code
    // Mark each product with the segment it's available in
    const combinedMap = new Map();
    catalogOutgoing.forEach((product) => {
      combinedMap.set(product.code, { ...product, availableInSegment: 'outgoing' });
    });
    catalogIncoming.forEach((product) => {
      if (combinedMap.has(product.code)) {
        // Product exists in both segments
        const existing = combinedMap.get(product.code);
        combinedMap.set(product.code, { ...existing, availableInSegment: 'both' });
      } else {
        combinedMap.set(product.code, { ...product, availableInSegment: 'incoming' });
      }
    });
    return Array.from(combinedMap.values());
  }

  return segment === 'outgoing' ? catalogOutgoing : catalogIncoming;
};

export default useProductsCatalog;
